import ExpoDevMenu from './ExpoDevMenu';

export function openMenu(): void {
  ExpoDevMenu.openMenu();
}

export function openProfile(): void {
  ExpoDevMenu.openProfile();
}

export function openSettings(): void {
  ExpoDevMenu.openSettings();
}
